<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>
    <div class="md-layout">

      <!-- 단체 목록 조회 -->
      <group-search-list-comp @returnResult="onClickBranch" ref="groupListSearch">
        <div slot="bottomRightArea">
          <md-card-actions md-alignment="space-between">
            <md-button class="md-info md-sm" @click="addBranchInit()">
              <md-icon>person</md-icon>신규 단체
            </md-button>
          </md-card-actions>
        </div>
      </group-search-list-comp>

      <!-- 상세정보 시작     -->
      <md-card v-if="this.isShowBasicInfo">
        <md-card-header md-alignment="space-between">
          <h4 class="title">
            <md-icon>description</md-icon>
            <span v-if="branchInfoQueryData.branchNm && branchInfoQueryData.branchNm != ''"> {{branchInfoQueryData.branchNm}} ({{branchInfoQueryData.branchId}}) - </span>
            단체 정보
          </h4>
        </md-card-header>
        <md-card-content>
          <table class="flex-table">
            <tr>
              <th>단체ID</th>
              <td><input type="text" v-model="branchInfoQueryData.branchId" disabled></td>
              <th>단체명</th>
              <td><input v-focus type="text" v-model="branchInfoQueryData.branchNm"></td>
              <th>단체 구분</th>
              <td>
                <select v-model="branchInfoQueryData.branchGb" >
                  <option v-for="item in branchTypeList" :key="item.code" :label="item.codeNm" :value="item.code"></option>
                </select>
              </td>
              <th>발송교우ID</th>
              <td>
                <div class="inline-flex">
                  <input type="text" v-model="branchInfoQueryData.postmemberNo" disabled>
                  <button @click="() => {this.isShowMemberModal = true; this.memberModalMode = 1;}">
                    <md-icon>search</md-icon>
                  </button>
                </div>
              </td>
              <th>발송교우명</th>
              <td><input type="text" v-model="branchInfoQueryData.postmemberNm" disabled></td>
            </tr>
            <tr>
              <th rowspan="6">주소</th>
              <td rowspan="6" colspan="3">
                <table class="table-in-td">
                  <tr>
                    <td rowspan="3">도로명주소</td>
                    <td>
                      <input type="text" class="w60" v-model="branchInfoQueryData.zipCd">
                      <button @click="addressModalOpen"><md-icon>search</md-icon></button>
                      <label><input type="checkbox">반송지 확인</label>
                      <label><input type="checkbox">수신거부</label>
                    </td>
                  </tr>
                  <tr>
                    <td><input type="text" v-model="branchInfoQueryData.address1"></td>
                  </tr>
                  <tr>
                    <td><input type="text" ref="address2" placeholder="상세주소" v-model="branchInfoQueryData.address2"></td>
                  </tr>
                </table>
              </td>
              <th>홈페이지</th>
              <td><input type="text" v-model="branchInfoQueryData.homepage"></td>
              <th>SNS주소</th>
              <td><input type="text" v-model="branchInfoQueryData.sns"></td>
              <th>전화번호</th>
              <td>
                <div class="inline-flex">
                  <input type="text" maxlength="15" v-model="branchInfoQueryData.tel">
                </div>
              </td>
            </tr>
            <tr>
              <th>국내외 구분</th>
              <td>
                <label><input type="radio" value="1" v-model="branchInfoQueryData.branchLevel" name="branchInfoQueryData.branchLevel" @change="chgForeignType">국내</label>
                <label><input type="radio" value="2" v-model="branchInfoQueryData.branchLevel" name="branchInfoQueryData.branchLevel" @change="chgForeignType">국외</label>
              </td>

              <th>국가 선택</th>
              <td>
                <div class="inline-flex">
                  <input type="text" disabled v-model="searchedNationalName"/>
                  <button @click="isShowNationalModal=true" :disabled="branchInfoQueryData.branchLevel=='1'">
                    <md-icon>search</md-icon>
                  </button>
                </div>
              </td>
              <th></th>
              <td>
                <div class="inline-flex">
                </div>
              </td>
            </tr>
            <tr>
              <th>지역</th>
              <td>
                <div class="inline-flex">
                  <select v-model="branchInfoQueryData.bornCd" >
                    <option v-for="item in bornCdList" :key="item.code" :label="item.codeNm" :value="item.code">
                    </option>
                  </select>
                </div>
              </td>
              <th>회보 부수</th>
              <td><input type="text" v-model="branchInfoQueryData.copies"></td>
              <th>&nbsp;</th>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <th>직장명</th>
              <td>
                <div class="inline-flex">
                  <input type="text" v-model="branchInfoQueryData.companyNm">
<!--                  <button @click="isShowCompanyModal=true"><md-icon>search</md-icon></button>-->
                </div>
              </td>
              <th>부서명</th>
              <td><input type="text" v-model="branchInfoQueryData.partNm"></td>
              <th>직위명</th>
              <td><input type="text" v-model="branchInfoQueryData.levelNm"></td>
            </tr>
          </table>
        </md-card-content>
        <md-card-actions md-alignment="right">
          <md-button class="md-info md-sm" @click="saveGroup">
            <md-icon>create</md-icon>등록
          </md-button>
          <md-button class="md-default md-sm" @click="deleteGroup();">
            <md-icon>clear</md-icon>삭제
          </md-button>
          <md-button class="md-default md-sm" @click="clearBranchInfoQueryData();">
            <md-icon>clear</md-icon>초기화
          </md-button>
        </md-card-actions>
      </md-card>


      <!--단체 교우 목록 - 추가/삭제/수정, 임원진 - 취임/퇴임 -->
      <div class="md-layout" v-show="this.isShowDetailInfo">
        <div class="md-layout-item md-size-20 no-padding">
          <md-card>
            <md-card-header md-alignment="space-between">
              <h4 class="title">
                <md-icon>person_add</md-icon>교우 추가
              </h4>
            </md-card-header>
            <md-card-content>
              <div class="flex-div">
                <h5 class="title">교우 검색 후 추가</h5>

                <md-button class="md-success md-sm full-size-button" @click="() => {this.isShowMemberModal = true; this.memberModalMode = 2;}">
                  <md-icon>open_in_new</md-icon>검색 팝업
                </md-button>
              </div>
              <hr>
              <div class="flex-div">
                <h5 class="title">대상 복사 붙여 넣기</h5>
                <div class="inline-flex mb10">
                  <textarea rows="10" class="h200" v-model="textAreaData"></textarea>
                </div>
                <div class="inline-flex mb10">
                  <select>
                    <option>교우번호</option>
                    <option>학번</option>
                  </select>
                </div>
                <md-button class="md-success md-sm full-size-button" :disabled="String(textAreaData).trim().length < 7" @click="uploadMemberList">
                  <md-icon>publish</md-icon>실행
                </md-button>
              </div>
            </md-card-content>
          </md-card>
        </div>
        <div class="md-layout-item md-size-50 no-padding">
          <!-- 단체 교우 목록 조회 -->
          <group-member-list-comp ref="groupMemberList">
            <div slot="bottomRightArea">
              <md-card-actions md-alignment="space-between">
                <md-button class="md-info md-sm" @click="deleteGoupMember">
                  <md-icon>person</md-icon>회원 삭제
                </md-button>
                <md-button class="md-info md-sm" @click="assumeExecutive(1)">
									<md-icon>person</md-icon>임원진 취임
								</md-button>
              </md-card-actions>
            </div>
          </group-member-list-comp>

        </div>

        <div class="md-layout-item md-size-30 no-padding">

          <!-- 임원진 목록 조회 -->
          <group-excutive-list-comp ref="groupExcutiveList">
            <div slot="bottomRightArea">
              <div class="pagination"></div>
              <md-card-actions md-alignment="right">
                <md-button class="md-default md-sm" @click="deleteHistory(2)">
                  <md-icon>clear</md-icon>history 삭제
                </md-button>
                <md-button class="md-info md-sm" @click="assumeExecutive(2)">
                  <md-icon>person</md-icon>임원진 수정
                </md-button>
              </md-card-actions>
            </div>
          </group-excutive-list-comp>

        </div>
      </div>

      <div id="scrollTargetBox"></div>
    </div>

    <!--교우검색 팝업 -->
    <member-search-pop-comp :is-show.sync="isShowMemberModal" @returnResult="onSelectedModalMember"></member-search-pop-comp>

    <!--주소검색 팝업 -->
    <postcode-pop-comp :is-show.sync="isShowPostcodeModal" @returnResult="handleAddress"></postcode-pop-comp>

    <!--국가선택 팝업 -->
    <nation-search-pop-comp :is-show.sync="isShowNationalModal" @returnResult="selectedNational"></nation-search-pop-comp>

    <!--직장선택 팝업 -->
    <company-search-pop-comp :is-show.sync="isShowCompanyModal" @returnResult="selectedCompany"></company-search-pop-comp>


    <!--임원진 취임,퇴임 팝업 -->
    <group-executive-comp ref="setExecutModal" :is-show.sync="hasShowExecutiveUserModal" :executive-mode.sync="setExecutMode" @returnResult="callbackSetExecut"></group-executive-comp>

  </div>
</template>

<script>
import URL_CONST from "@/kuaa/kuaa-url-const";
import formatter from "@/kuaa/kuaa-formatter";
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';
import kuaaApi from "@/kuaa/kuaa-api";
import axios from "axios";
import Swal from "sweetalert2";
import kuaaFnc from "@/kuaa/kuaa-comm-func";



import { MemberSearchPopComp, WorkSearchPopComp, CompanySearchPopComp, CollegeSearchPopComp, ClassSearchPopComp, NationSearchPopComp, PostcodePopComp } from "@/pages"
import GroupSearchListComp from "@/pages/MembershipGroup/Components/GroupSearchListComp";
import GroupMemberListComp from "@/pages/MembershipGroup/Components/GroupMemberListComp";
import GroupExcutiveListComp from "@/pages/MembershipGroup/Components/GroupExcutiveListComp";
import GroupExecutiveComp from "@/pages/MembershipGroup/Components/GroupExecutiveComp";

export default {
  components: {
    GroupSearchListComp,
    MemberSearchPopComp,
    PostcodePopComp,
    NationSearchPopComp,
    CompanySearchPopComp,
    GroupMemberListComp,
    GroupExcutiveListComp,
    GroupExecutiveComp
  },
  computed: {
  },

  created() {
    this.queryBranchTypes();
    this.queryBornCdTypes();
  },

  data() {
    return {
      hasShowExecutiveUserModal : false,
      showMemberListMode : 1, // 그리드 모드 임원/단체 교우 목록 1-> 단체 2-> 임원
      setExecutMode : 1, // 임원진 취임, 퇴임 모드 1-> 취임 2-> 퇴임

      // 교우조회
      isShowMemberModal : false,
      memberModalMode : null,

      // 주소검색
      isShowPostcodeModal : false,

      //국내외 구분
      branchLevel : '1',
	  
	  memberNo : "",
	  
      query: {
        branchNm: "",
        memberHnm: "",
        branchGb: ""
      },

      // 단체구분 종류
      branchTypeList: [],

      // 지역
      bornCdList : [],

      // 국가검색
      isShowNationalModal : false,
      searchedNationalName : '',

      // 직장선택
      isShowCompanyModal : false,

      textAreaData : '',

      branchMemberListData: [], // 단체 회원

      isShowBasicInfo: false,
      isShowDetailInfo: false,

      // 속성정보 확인 필요
      branchInfoQueryData : {
      	"memberNo" : "",
        "branchId": "", // 단체ID
        "branchGb": "B", // 단체구분 todo api 되면 바꿔야 함.
        "updateDate": null,
        "address3": "",
        "address2": "",
        "bornCd": "",
        "address1": "", // 주소
        "companyNm" : "",
        "userNo": "",
        "insertDate": null,
        "nationalCd": null,
        "nationalNm": null,
        "zipCd": "",  // 우편번호
        "levelNm": "",
        "branchLevel": "",  // 단체등급
        "addressGb": "",
        "companyId": "",
        "copies": 0,
        "postmemberNm": "", // 발송교우명
        "postmemberNo": "", // 발송교우ID
        "partNm": "",
        "erectDate": "",
        "tel": "",
        "address5": null,
        "address4": null,
        "homepage" : "",
        "sns" : "",
        "branchNm": ""  // 단체명
      }
    };
  },

  methods: {
    /**
     * branch - 공통코드 조회 세팅
     */
    queryBranchTypes() {
      kuaaFnc.fncBranchTypes(null,res => {
        this.branchTypeList = res.data.data.contents;
      });
    },

    /**
     * 지역 검색 - 공통코드 조회 세팅
     */
    queryBornCdTypes() {
      kuaaFnc.fncBornCodes(null,res => {
        this.bornCdList = res.data.data.contents;
      });
    },

    clearBranchInfoQueryData () {
      this.branchInfoQueryData = {
        "memberNo" : "",
        "branchId": "", // 단체ID
        "branchGb": "B", // 단체구분 todo api 되면 바꿔야 함.
        "updateDate": null,
        "address3": "",
        "address2": "",
        "bornCd": "",
        "companyNm" : "",
        "address1": "", // 주소
        "userNo": "",
        "insertDate": null,
        "nationalCd": null,
        "zipCd": "",  // 우편번호
        "levelNm": "",
        "branchLevel": "",  // 단체등급
        "addressGb": "",
        "companyId": "",
        "copies": 0,
        "postmemberNm": "", // 발송교우명
        "postmemberNo": "", // 발송교우ID
        "partNm": "",
        "erectDate": "",
        "tel": "",
        "address5": null,
        "address4": null,
        "homepage" : "",
        "sns" : "",
        "branchNm": ""  // 단체명
      }
      // tui radio 미지원. 대체 코드
      document.getElementsByName('selectedBranch').forEach((el)=>{el.checked=false});
    },

    onClickMemberCnt (item){
      this.toggleDetailInfo(true,item);
      if(item.branchId.substring(0,1) == "Z"){
        this.queryBranchMemberList(item.branchId, "Z");
      }else{
        this.queryBranchMemberList(item.branchId);
      }
      this.queryExcutiveMemberList(item.branchId);
    },
    onClickBranchNm (item){
      this.toggleBasicInfo(true,item);
    },

    addBranchInit(){
      this.clearBranchInfoQueryData();
      this.onClickBranchNm();
      this.branchInfoQueryData.branchLevel = '1';
    },

    toggleBasicInfo(bool,item){
      if (bool){
        this.isShowDetailInfo = false;
        if(item){
            this.searchedNationalName = item.nationalNm;
          	this.branchInfoQueryData.nationalCd = item.nationalCd;	
          this.branchInfoQueryData = item;
        }else{
          this.clearBranchInfoQueryData();
        }
      }
      this.isShowBasicInfo = bool;
    },
    toggleDetailInfo(bool,item){
      this.isShowDetailInfo = bool;
      if (bool){
        this.isShowBasicInfo = false;
        this.branchInfoQueryData = item;
      }
    },

    /**
     * 단체 목록 그리드 클릭
     * 아래쪽 단제 정보 영역에 세팅 해 줌
     */
    onClickBranch(item, columnName) {
      switch (columnName) {
        case ('branchNm') :
          // 단체명 클릭
          this.onClickBranchNm(item);
          break;
        case ('memberCnt') :
          // 회원수 클릭
          this.onClickMemberCnt(item);
          break;
      }
      kuaaFnc.scrollTo('scrollTargetBox');
    },

    /**
     * 단체 회원 조회
     */
    queryBranchMemberList(branchId, branchGb) {
      this.$refs.groupMemberList.clearView();
      this.$refs.groupMemberList.sendQuery({branchId : branchId, branchNm:this.branchInfoQueryData.branchNm, branchGb:branchGb});
    },

    queryExcutiveMemberList(branchId) {
      this.$refs.groupExcutiveList.sendQuery({branchId : branchId, branchNm:this.branchInfoQueryData.branchNm});
    },

    chgForeignType () {
      // 국내로 체크했을 경우 기존 선택 된 국가를 지운다
      if(this.branchInfoQueryData.branchLevel == '1'){
        this.searchedNationalName = '';
        this.branchInfoQueryData.nationalCd = null;
      }
    },

    uploadMemberList() {
      let list = this.textAreaData.split("\n");
      let memberArr = [];
      list.forEach((item)=>{
        memberArr.push({memberNo:item});
      })
      this.addGoupMember(memberArr);
    },

    addGoupMember (item){
      if(!this.branchInfoQueryData.branchId || this.branchInfoQueryData.branchId == ''){
        Swal.fire(kuaaFnc.getSwalModaloptions({
          html: "단체를 선택 하세요",
        }))
        return;
      }

      let params = [];
            
      item.forEach((obj)=>{
        if(obj.memberNo) {
          params.push({
            branchId : this.branchInfoQueryData.branchId,
            memberNo : obj.memberNo
          });
        }
      });
      
      
      let firstBranchId = this.branchInfoQueryData.branchId.substring(0,1);
      
      let branchGb;
      
      if(firstBranchId = "Z"){
      	branchGb = "Z"
      }else{
      	branchGb = ""
      }
      
      let modalOptions1 = kuaaFnc.getSwalModaloptions();

	  let option = {
      	branchId : this.branchInfoQueryData.branchId,
      	branchNm : this.branchInfoQueryData.branchNm,
      	branchGb : branchGb,
      	memberNo : item[0].memberNo
      }
      
      if(firstBranchId != "J" && firstBranchId != "B"){
      	this.addGoupMemberdetail(params);
      } else{
      	kuaaApi.sendServer(
	        URL_CONST.GET_BRANCH_MEMBER_LIST,
	        option,
	        "post",
	        response => {
	        	if(response.data.data.contents.length > 0){
	        		modalOptions1.html = '이미' + response.data.data.contents[0].branchNm + '의 회원입니다.';
	                Swal.fire(modalOptions1);
	        	}else{
	        		this.addGoupMemberdetail(params);
	        	}
	        }
	     );
	  }
    },

	addGoupMemberdetail(params){
		let modalOptions = kuaaFnc.getSwalModaloptions('confirm',{
			html: "선택한 교우를 그룹에 추가 하시겠습니까?",
		});
		
		Swal.fire(modalOptions).then(result => {
			if (result.value) {
				kuaaApi.sendServer(
					URL_CONST.SAVE_BRANCH_MEMBER,
					params,
					"post",
					response => {
						if (response.data.success){
              kuaaFnc.showSwal("교우 추가", `단체에 추가 하였습니다.`);
							this.$refs.groupMemberList.sendQuery({branchId : this.branchInfoQueryData.branchId, branchNm:this.branchInfoQueryData.branchNm, branchGb:this.branchInfoQueryData.branchGb});
							this.showMemberListMode = 1;
							this.textAreaData = '';
						} else {
							modalOptions.html = `단체 추가 실패 하였습니다.`;
							Swal.fire(modalOptions);
						}
					}
				);
			}
		});
	},
	
    deleteGoupMember (){
      let selectedMembers = this.$refs.groupMemberList.getSelectedMember();
      let params = [];

      if(!this.branchInfoQueryData.branchId || this.branchInfoQueryData.branchId == ''){
        Swal.fire(kuaaFnc.getSwalModaloptions({
          html: "단체를 선택 하세요",
        }))
        return;
      }
      
      if(selectedMembers.length < 1){
        Swal.fire(kuaaFnc.getSwalModaloptions({
          html: "교우를 선택 하세요",
        }))
        return;
      }
      
      selectedMembers.forEach((obj)=>{
        params.push({
          branchId : obj.branchId,
          memberNo : obj.memberNo,
          positionNm : obj.positionNm,
          memberHnm : obj.memberHnm,
        });
      });
      
      for(let i=0; i<params.length; i++){
      	if(params[i].positionNm != null){
	        Swal.fire(kuaaFnc.getSwalModaloptions({
	          html: params[i].memberHnm + "이(가) 임원진에 속해있습니다. 임원 퇴임후 삭제하여 주세요",
	        }))
	        return;
	      }
      }

      let modalOptions = kuaaFnc.getSwalModaloptions('confirm',{
        html: "선택한 교우를 그룹에서 삭제 하시겠습니까?",
      });
      Swal.fire(modalOptions).then(result => {
        if (result.value) {
          modalOptions = kuaaFnc.getSwalModaloptions();
          kuaaApi.sendServer(
            URL_CONST.DELETE_BRANCH_MEMBER,
            params,
            "post",
            response => {
              if (response.data.success){
                modalOptions.html = `삭제 되었습니다.`;
                Swal.fire(modalOptions);
                this.$refs.groupMemberList.sendQuery({branchId : this.branchInfoQueryData.branchId, branchNm:this.branchInfoQueryData.branchNm, branchGb : this.branchInfoQueryData.branchGb});
              } else {
                modalOptions.html = `삭제 실패 하였습니다.`;
                Swal.fire(modalOptions);
              }
            }
          );
        }
      });
    },

    setModalPostmember (item){
      this.branchInfoQueryData['postmemberNo'] = item.memberNo;
      this.branchInfoQueryData['postmemberNm'] = item.memberHnm;
    },

    onSelectedModalMember (item){
      switch (this.memberModalMode) {
        case 1 : this.setModalPostmember(item);
          break;
        case 2 : this.addGoupMember([item]);
          break;
      }
      this.memberModalMode = null;
    },
    addressModalOpen: function(event) {
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }
      this.isShowPostcodeModal = true;
    },
    handleAddress: function(data) {
      let zonecode = data.zonecode; // 우편번호
      let roadAddress = data.roadAddress; // 도로명주소
      let jibunAddress = data.jibunAddress; // 지번 주소
      let fullAddress = data.address; // 기본주소
      let extraAddress = "";

      if (data.addressType === "R") {
        if (data.buildingName !== "") {
          extraAddress += ' (' + data.buildingName + ')';
        }
      }

      this.branchInfoQueryData.zipCd = zonecode;
      this.branchInfoQueryData.address1 = roadAddress;
      this.branchInfoQueryData.address2 = extraAddress;

      let address2 = this.$refs.address2;
      setTimeout(function() {
        address2.focus();
        address2.setSelectionRange(0, 0);
      }, 100);

      this.isShowPostcodeModal = false;
    },
    selectedNational(item) {
      this.searchedNationalName = item.codeNm; //화면 표시용
      this.branchInfoQueryData.nationalCd = item.code;//DB 저장용
    },
    selectedCompany: function(item) {
      this.isShowCompanyModal = false;
      this.branchInfoQueryData.companyNm = item.codeNm;
      this.branchInfoQueryData.companyId = item.code;
    },

    addGroup () {
      let modalOptions = kuaaFnc.getSwalModaloptions();
      kuaaApi.sendServer(
        URL_CONST.SAVE_BRANCH,
        this.branchInfoQueryData,
        "post",
        response => {
          if (response.data.success){
            modalOptions.html = `단체 저장 되었습니다.`;
            Swal.fire(modalOptions);
            this.$refs.groupListSearch.searchQuery();
            this.clearBranchInfoQueryData();
          } else {
            modalOptions.html = `단체 저장 실패 하였습니다.`;
            Swal.fire(modalOptions);
          }
        }
      );
    },

    updateGroup () {
      let modalOptions = kuaaFnc.getSwalModaloptions();
      kuaaApi.sendServer(
        URL_CONST.UPDATE_BRANCH,
        this.branchInfoQueryData,
        "post",
        response => {
          if (response.data.success){
            modalOptions.html = `단체 수정 되었습니다.`;
            Swal.fire(modalOptions);
            this.$refs.groupListSearch.searchQuery();
            this.clearBranchInfoQueryData();
          } else {
            modalOptions.html = `단체 수정 실패 하였습니다.`;
            Swal.fire(modalOptions);
          }
        }
      );
    },

    deleteGroup (){
      let modalOptions = kuaaFnc.getSwalModaloptions();

      if(!this.branchInfoQueryData.branchId || this.branchInfoQueryData.branchId ==''){
        modalOptions['html'] = '그룹을 선택 해 주세요';
        Swal.fire(modalOptions);
        return
      }else{
        modalOptions = kuaaFnc.getSwalModaloptions('confirm',{
          html: "선택한 그룹을 삭제 하시겠습니까?",
        });


        Swal.fire(modalOptions).then(result => {
          if (result.value) {
            kuaaApi.sendServer(
              URL_CONST.DELETE_BRANCH,
              {branchId:this.branchInfoQueryData.branchId },
              "post",
              response => {
                modalOptions = kuaaFnc.getSwalModaloptions();
                if (response.data.success){
                  modalOptions.html = `단체가 삭제 되었습니다.`;
                  Swal.fire(modalOptions);
                  this.clearBranchInfoQueryData();
                  this.$refs.groupListSearch.searchQuery();
                } else {
                  modalOptions.html = `단체 삭제 실패 하였습니다.`;
                  Swal.fire(modalOptions);
                }
              }
            );
          }
        });

      }
    },
    saveGroup(){
      let modalOptions = kuaaFnc.getSwalModaloptions();

      if(!this.branchInfoQueryData.branchGb || this.branchInfoQueryData.branchGb == ''){
        modalOptions.html = '단체구분을 선택 해 주세요.';
        Swal.fire(modalOptions);
        return;
      }

      if(!this.branchInfoQueryData.branchNm || this.branchInfoQueryData.branchNm == ''){
        modalOptions.html = '단체명을 입력해 주세요.';
        Swal.fire(modalOptions);
        return;
      }

      if(this.branchInfoQueryData.branchId && this.branchInfoQueryData.branchId != ''){
        this.updateGroup();
      }else{
        this.addGroup();
      }
    },

    // 임원진 취임
    assumeExecutive(mode){
      let rows;
      if(mode == 1){
        rows = this.$refs.groupMemberList.getSelectedMember();
      }else{
        rows = this.$refs.groupExcutiveList.getSelectedMember();
      }
      if(rows.length < 1){
        Swal.fire(kuaaFnc.getSwalModaloptions({html:'대상교우를 선택해 주세요'}));
        return;
      }
      if(rows.length > 1){
        Swal.fire(kuaaFnc.getSwalModaloptions({html:'대상교우를 한명만 선택해 주세요'}));
        return;
      }
      
      if(mode == 1 && rows[0].positionNm != null){
      	Swal.fire(kuaaFnc.getSwalModaloptions({html:'해당교우는 이미 임원진 입니다. 임원진 목록에서 수정하여 주세요.'}));
        return;
      }
      
      this.hasShowExecutiveUserModal = true;
      this.setExecutMode = mode;
      this.$refs.setExecutModal.setData(rows[0]);
    },

    // 임원진 취임
    deleteHistory(){
      let rows = this.$refs.groupExcutiveList.getSelectedMember();
      if(rows.length < 1){
        Swal.fire(kuaaFnc.getSwalModaloptions({html:'대상교우를 선택해 주세요'}));
        return;
      }
      if(rows.length > 1){
        Swal.fire(kuaaFnc.getSwalModaloptions({html:'대상교우를 한명만 선택해 주세요'}));
        return;
      }

      let modalOptions = kuaaFnc.getSwalModaloptions('confirm',{
        html: "삭제 하시겠습니까?",
      });

      Swal.fire(modalOptions).then(result => {
        if (result.value) {
          kuaaApi.sendServer(
            URL_CONST.DELETE_BRANCH_ORG,
            {
              branchId : rows[0].branchId,
              memberNo : rows[0].memberNo,
              erectDate : rows[0].erectDate
            },
            "post",
            response => {
              modalOptions = kuaaFnc.getSwalModaloptions();
              if (response.data.success){
                modalOptions.html = `삭제 되었습니다.`;
                Swal.fire(modalOptions);
                this.$refs.groupListSearch.searchQuery();
                this.queryBranchMemberList(rows[0].branchId,rows[0].branchGb);
                this.queryExcutiveMemberList(rows[0].branchId,rows[0].branchGb);
                this.clearBranchInfoQueryData();
              } else {
                modalOptions.html = `삭제 실패 하였습니다.`;
                Swal.fire(modalOptions);
              }
            }
          );
        }
      })

    },
    callbackSetExecut(){
      this.toggleDetailInfo(true,this.branchInfoQueryData);
      this.queryBranchMemberList(this.branchInfoQueryData.branchId,this.branchInfoQueryData.branchGb);
      this.queryExcutiveMemberList(this.branchInfoQueryData.branchId,this.branchInfoQueryData.branchGb);
    }
  }
}
</script>

<style>

</style>